export const pnbConstants = {
  exportConstants: {
    providerNegotiationBriefing: 'Provider Negotiation Briefing',
    footercontent: 'United HealthCare Services, Inc. All rights reserved.',
    footerContent2: 'CONFIDENTIAL – For internal use only. Do not distribute.',
    errorCreatingDoc: 'Error creating document:',
    sourceDocument: 'Source Document',
    insertProviderName: '[Insert Provider Name]',
    providerProfile: 'Provider Profile',
    providerDetails: 'Provider Details',
    tableOfContent: 'Table of Contents',
    white: 'ffffff',
    FIELD_GREY: 'FAFAFA',
    fullBlack: '000000',
    tocColor: '2D2D39',
    normal: 'Normal',
    toc: 'TOC',
    hyperlink: 'Hyperlink',
    pnbDoc:
      'https://uhgazure.sharepoint.com/:b:/r/teams/UHNContractorLearning/Catalog/Prep%20Phase%20Source%20Documents/Provider%20Briefing%20Source%20Document.pdf?csf=1&web=1&e=RqwLyH',
    docInstruction:
      'For instructions on how to complete and store the Provider Negotiation Briefing, see the ',
    uhcBlue: '0288d1',
    descBlue: 'b3e5fc',
    lightGrey: '8C8C9A',
    whiteGrey: 'f3f3f3',
    darkBlue: '002671',
    headerOrange: 'ff6f00',
  },
  PROVIDER_PROFILE_TAB: {
    PROVIDER_NAME: 'Provider Name',
    RELATIONSHIP_STATUS: 'Relationship Status',
    HEADQUARTERS: 'Headquarters',
    UHC_CUSTOMER: 'UHC Customer',
    LEADERSHIP: 'Leadership',
    PRIVATE_EQUITY_BACKED: 'Private Equity Backed',
    FINANCIAL_STATUS: 'Financial Status',
    SPEND: 'Spend',
    MAJORITY_FIN_OWNERSHIP: 'Majority Financial Ownership',
    UHG_AFFILIATE:
      'Is The Provider A UHG Affiliate per the Legal Entities list in the NC-74 policy?',
    ASC: '# Ambulatory Surgical Centers (ASC)',
    AIS: '# Ambulatory Infusion Suites (AIS)',
    HIT: '# Home Infusion Centers (HIT)',
    SP: '# Specialty Pharmacy (SP)',
    HTC: '# Hemophilia Treatment Centers (HTC)',
    FACILITY: 'FACILITY',
    TOTAL_HOSPITALS: '# Hospitals',
    TOATL_BEDS: '# Beds',
    OUTPATIENT_CENTERS: 'Outpatient Centers',
    PHYSICIANS: '# Physicians',
    FEDERAL_GROUPS:
      '# Federally Qualified Health Centers (FQHC), # FQHC Look-Alike (FQHCLA), # Rural Health Centers (RHC), # Tribal Health Center (THC)',
    PRIVATE_EQUITY_NAME: 'Private Equity Name (If applicable)',
    IFP: 'IFP',
    TOTAL_SPEND: 'Total Spend',
    TOTAL_FINANCIAL_COUNT: 'Total Financial Count',
    TOTAL_ADMINISTRATIVE_COUNT: 'Total Administrative Count',
    TIERS: 'TIERS',
    PROFITABLE: '% Profitability',
    ANCILLARY: '# Ancillary',
    PROVIDER_GROUP: '# Provider Groups',
  },
  PNS_TAB: {
    PNS: 'Provider Negotiation Strategy',
    STRATEGY_NARRATIVE: 'Strategy Narrative',
    FINAL_RIDE_IDS: 'Final RIDE IDs',
    RIDE_REQUEST_ID: 'RIDE Request ID #',
    PRIMARY_OBJECTIVES: 'Primary Objectives',
    TIMING_CURRENT_LANDSCAPE: 'Timing and Current Landscape',
    TACTICS: 'Tactics',
    FINANCIAL_PARAMS: 'Financial Parameters',
    RATES_LANGUAGE_LEVERS: 'Rates, Language and Levers',
    MERGER_ACQUISITION_ACTIVITY: 'Merger & Acquisition activity',
    UHN_LEADERSHIP_SIGNS: 'UHN Contract Signatures',
    MA_RED_FLAG_TOOL_UTILIZED: 'Was the Merger & Acquisition Red Flag Tool Utilized?',
    PROVIDER: 'Provider',
    DATE: 'Date',
    IMPACT: '$ Impact',
    CATEGORY: 'Category',
    FIRST_OFFER: 'First Offer',
    BAFO: 'Best and Final Offer (BAFO)',
    CURRENT_UHC_BID: 'Current UHC Bid',
    CURRENT_PROVIDER_ASK: 'Current Provider Ask',
    TERM: 'Term',
    RATES: 'Rates',
    BID_ASK_GAP: 'Bid/Ask Gap',
    LANGUAGE: 'Language',
    UHCRT_CURRENT_PROJECTION: 'UCRT Current Projection (% and dollar impact)',
    UCRT_ACTUAL: 'UCRT Actual (% and dollar impact)',
    UCRT_IMPACT: 'UCRT Impact (dollar impact)',
    PROPOSAL_IMPACT_LIST: ['Total_EI', 'FI_Only', 'CS', 'MR'],
    PROPOSAL_IMPACT_LIST2: ['BAFO_NEF', 'UHC_Bid_NEF', 'Provider_Ask_NEF'],
    PI_CURRENT_NEF: 'Proposal Impact Current NEF',
    YEAR: 'Year',
    UHN_LEADERSHIP: 'UHN Leadership',
    DATE_AIGN_RECIEVED: 'Date Signature Received',
    LEAD_CONTRACTOR_NAME: 'Lead Contractor Name:',
    MARKET_LEAD_NAME: 'Market Lead/RVP Name:',
    MANAGER_NAME: 'Manager Name:',
    DIRECTOR_NAME: 'Director Name:',
    ADDITIONAL_LEADERSHIP_SIGNATURES: 'Any Additional Leadership Signatures:',
    TRANSFORM_TEXT: {
      Total_EI: 'Total E&I',
      FI_Only: 'FI Only',
      CS: 'C&S',
      MR: 'M&R',
      BAFO_NEF: 'BAFO NEF',
      UHC_Bid_NEF: 'UHC Bid NEF',
      Provider_Ask_NEF: 'Provider Ask NEF',
    },
  },
  CURRENT_STATE_TAB: {
    CURRENT_STATE: 'Current State',
    ANCILLARY: 'ANCILLARY',
    CURRENT_RELATIONSHIP: 'Current Relationship + Contract Details',
    BASE_LINE: 'Baseline Contract Score / Rates',
    BASE_RATE: 'Base Review / Rates & Language',
    NON_STANDARD: 'Non Standard Language',
    EXTERNAL_LEADERSHIP: 'External Leadership / Contacts',
    MEMBERSHIP_MARKET: 'UnitedHealthcare Membership and Market Share Position',
    LOB: 'Line of Business',
    COMMERCIAL: 'Commercial',
    MARKET_NAME: 'Market Name',
    MEDICARE: 'Medicare',
    MEDICATE: 'Medicaid',
    IFP: 'IFP',
    MEMBERSHIP: 'Membership',
    MEBERSHIP_BY_LOB: 'Membership by Line of Business',
    MARKET_SHARE: 'Market Share',
    MARKET_RANKING: 'Market Ranking ',
    NUMERICAL: 'On a numerical scale with 1 being the best',
    FI: 'FI',
    ASO: 'ASO',
    COMPETITIVENESS: 'Market Competitiveness',
    NEF: 'UHC Market Network Efficiency Factor (NEF)',
    PROVIDER_NEF: 'UHC Provider NEF',
    BIC: 'Provider Best in Class (BIC) Payor Name',
    INSIGHT_FACTOR: 'Market Insights and Factors',
    CORRENT_CONTRACT: 'Current Contract Terms',
    RENEWAL_DATE: 'Renewal Term Date',
    RATE_PROVISION: 'Current Contract/Term/Rate Provision',
    HISTORICAL_INCREASES: 'Historical Increases',
    AVERAGE_VALUE: 'Average Value',
    CUMULATIVE_VALUE: 'Cumulative Value',
    CPI: 'CPI (Inflationary Cost Pressure) (Physician)',
    PAPER_TYPE: 'Paper Type and Version',
    NON_I_STANDARD_LANGUAGE: 'Non-Standard Language',
    CARE_ASSIST: 'Point of Care Assist',
    RATE_METHODOLOGY:
      'Contract Rate Methodology and Competitiveness Overview (By Line of Business)',
    BIGGEST_TREND: 'Biggest Trend Drivers Across All Lines of Business',
    COMMERCIAL_COST: 'Commercial Unit Cost Reporting Template (UCRT) Projection',
    PPR: 'Commercial Exposure to Percentage of Payment Rate (PPR)',
    INPATIENT: 'Inpatient %',
    OUTPATIENT: 'Outpatient %',
    TOTAL: 'Total %',
    COMMERCIAL_PPR: 'Commercial PPR Equivalent',
    HOSPITAL_COST: 'Hospital Cost to Charge',
    COMMERCIAL_BIC: 'Commercial BIC Position',
    PAYOR: 'Payor',
    HOSPITAL: 'Hospital',
    PHYSICIAN: 'Physician',
    COMBINED_BIC: 'Combined System BIC',
    COMMERCIAL_PROVIDER: 'Commercial Provider Relativity to Peers',
    FACILITY: 'Facility RVU',
    HIGHER_THAN: 'Higher Than',
    LOWERR_THAN: 'Lower Than',
    MARKET: 'Market',
    COMMERCIAL_RATE: 'Commercial Rate as % of CMS',
    COMMERCIAL_PAY: 'Commercial Pay Apps',
    COMMERCIAL_FEE_SCHEDULE: 'Commercial Fee Schedule',
    INDIVIDUAL:
      'Individual & Family Plan (If Applicable) Leave Blank if the providers not located in a market that is active/targeted for IFP plans',
    IFP_REM: 'IFP Reimbursement',
    FACILITY_PRICING: 'Facility Pricing Zone',
    ASC: 'ASCs',
    GLOBAL_CAP: 'Global cap rate',
    IFP_BIC: 'IFP BIC Position / Market Competitiveness',
    RATE_DIFFERENCE: 'Rate Difference',
    PREMIUM_POSITION: 'Premium Position',
    PRICING_ZONE: 'Pricing Zone',
    IFP_REMEDIATION: 'IFP Remediation',
    TARGET: 'Target',
    HOSPITAL_TARGET: 'Hospital Target',
    HOSPITAL_STRATEGY: 'Hospital Strategy',
    PHY_TARGET: 'Physician Target',
    ANC_TARGET: 'Ancillary Target',
    IFP_FEE: 'IFP Fee Schedule',
    MEDICARE_REMEDIATION: 'Medicare Remediation',
    SAVINGS: 'Savings',
    STATE_RATE: 'State Rate',
    MEDICARE_REM: 'Medicare Reimbursement',
    CURRENT_FACILITY: 'Facility',
    PHYSICIANS: 'Physicians',
    MEDICARRE_APPS: 'Medicare Pay Apps',
    MEDICARRE_FEE_SCHEDULE: 'Medicare Fee Schedule',
    MEDICAID_REM: 'Medicaid Remediation',
    MEDICAID_REIMBURSEMENT: 'Medicaid Reimbursement',
    MEDICAID_APPS: 'Medicaid Pay Apps',
    EXCLUSIONS: 'Exclusions/Exceptions',
    AFFORDABILITY: 'Affordability',
    APRN: ' i.e., APRN, CLIA Pause, DDP, EDC Analyzer, GI Endo, Hospital Observation, Hospital Reference Lab, Pharmacy – Admin Guide, Site of Service, 3-Day Window',
    APRN_TIER1_TIER2: 'i.e, APRN, GI Endo, Site of Service',
    VALUE_BASED: 'Value-Based Reimbursement',
    VBR_TIER1_TIER2:
      'i.e, Non-standard Language, Payment Integrity, Overpayment Recovery Team, Accounts Receivable',
    LANGUAGE:
      ' i.e., Non-Standard Language, Rad/Card Prior Auth, Enhanced Accounts Receivable, IRO, Level of Care/Length of Stay, Payment Integrity, Overpayment Recovery Team',
    COMPETITIVENESS_ST: 'Competitiveness',
    CLIENT_SPECIFIC:
      ' i.e., Client-Specific Rate Differentials, HPBC/PPBC, Lump Sum Cash Payments, Designated Data Steward, Retro Load Approval',
    COMP_TIER1_TIER2: 'i.e, PPBC, Retro Load Approval, Designated Data Steward',
    OPERATION_OVERVIEW: 'Operations Overview',
    DOMOGRAPHIC: 'Demographic Coverage',
    RELATIONSHIP_OVERVIEW: 'Relationship Overview',
    OPTUM_RELATIONSHIP: 'Optum Relationship',
    LEADERSHIP_CONTACTS: 'Leadership / Contacts',
    PRIMARY_CONTACT: 'Primary Contact Name / Title',
    BIO_ROLE: 'Bio / Role in the relationship',
    CFO_NAME: 'CFO Name / Title',
    OTHER_CONTACTS: 'Other Contacts Name / Title',
    PROVIDER_CLASS: 'Provider Best in Class (BIC) Payor',
    TIC_DATA: 'TIC Data (include all payors and all LOB)',
    HISTORICAL_FI: 'Historical Increases E&I (FI Only)',
    AVERAGE_ANNUAL: 'Average annual value',
    CUMULATIVE_ANNUAL: 'Cumulative Value over term of agreement',
    HISTORICAL_LOB: 'Historical Increases all LOB (FI)',
    PAYMENT_APPENDIX: 'Payment Appendix',
    OTHER_NETWORKS: 'Other Networks and Additional Commentary',
    COMMERCIAL_UNIT: 'Commercial Unit Cost Reporting Template (UCRT) Projection - FI Only',
    COMMERCIAL_EXPOSURE: 'Commercial Exposure to Percentage of Payment Rate (PPR) - FI Only',
    COMM_REMEDIATION: 'Commercial Remediation',
    REMEDIATION_TARGET: 'Remediation Target',
    DESCRIBE_REM: 'If Yes, Describe Remediation Goals',
    COMMERCIAL_REIM: 'Commercial Reimbursement',
    CURRENT_PERCENTAGE: 'Current % of Medicare',
    FEE_SCHEDULE: 'Year of Fee Schedule, or put Current Year, if applicable',
    IFP_REMBURSEMENT: 'IFP Reimbursement, Remediation & Pay App',
    YEAR_FEE: 'Year of Fee Schedule, or Put Current Year if applicable',
    PASP: 'PASP?',
    MEDICAID_PERCENTAGE: 'Current Rate as % of Medicaid',
    CLAIMS_YIELD: 'Claims Yield/Contract Yield',
    ACTIVE_SETTLEMENT: 'Active Settlements',
    PAST_REASON: 'Reason for Past Settlements',
    TOP_REASONS: 'Top 3 Reasons for Claims Non-Payment',
    LOB_SUMMARY: 'Summary of Claims Non-Payment by LOB',
    EI: 'E&I',
    MR: 'M&R',
    CS: 'C&S',
    PI_CLAIMS: 'PI - % of Claims with Medical Record Requests',
    SUBMITTED: 'Submitted',
    DENIED: 'Denied',
    PERFORMANCE_PROGRAM: 'Performance and Value-Based Programs',
    OPTUM_AUDIT: 'Optum Claim Audit/Medical Claim Review',
    ADDITIONAL_COMMENTS: 'Additional Comments',
    GRAY: '002671',
    ARIAL: 'Arial (body)',
    BORDER: 'E5E5E5',
    BLACK: '2D2D39',
    LIGHT_BLUE: '0288d1',
    EI_Total: 'E&I Total',
    MEDICAL_FEE_SCHEDULE: 'Medicare Fee Schedule',
    GROSS_YIELD: 'Gross Yield',
    CONTRACT_YIELD: 'Contract Yield',
    EXCLUSIONS_AFFORDABILITY: [
      'EDC Analyzer',
      'Prior Authorization Radiology',
      'Prior Authorization Cardiology',
      'Site of Service Radiology',
      'Site of Service Surgeries',
      'Hospital Reference - Lab',
      'DDP Lab',
      'DDP Imaging',
      'Medication Sourcing All OP Providers',
      'Medication Sourcing OP Hospital Only',
      'Medication Sourcing Low Cost Drugs',
      'Advanced Practice Provider (APRN)',
    ],
    EXCLUSIONS_VBR: ['IP - Length of Stay', 'IP - Level of Care', 'IRO', 'Designated Data Stewart'],
    EXCLUSIONS_COMPETITIVENESS: ['3 Day Window'],
    CONTRACT_ALLOWANCE: 'Contract Allowance (RIDE) Details',
  },
  PNB_DOCUMENT_URL: '/provider-briefing/document',
  ERROR_REDIRECTING: 'Error redirecting to document:',
  EXPLANATION: 'explanation',
  ADVANCE_NOTICE_TERM: 'advance notice of term',
  ENTER_HEALTHSYSTEM_TAX_ID: 'Please enter a Health System or Tax ID',
  SELECT_TEMPLATE_TYPE: 'Please select a Template Type',
  ENTER_LIST_NAME: 'Please enter a List Name',
  ENTER_TAX_ID_NUMBER_NAME: 'Please enter a Tax ID Number(s) or Name(s)',
  ERROR: 'Error',
  NA: 'N/A',
  NO_START_DATE: 'No Start Date',
  NO_END_DATE: 'No End Date',
  MEMBERSHIP_COLUMN_NAME: 'Membership by Line of Business',
  LOB_MARKET_NAME_KEY:
    'unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.marketName.membership',
  LOB_COMMERCIAL_KEY:
    'unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.commercial.membership',
  LOB_MEDICARE_KEY:
    'unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.medicare.membership',
  LOB_MEDICAID_KEY:
    'unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.medicaid.membership',
  LOB_IFP_KEY: 'unitedHealthcareMembershipMarketSharePosition.lineOfBusiness.ifp.membership',
  XXM: '[XXM]',
  TEMPLATE_TYPE: 'Template Type',
  AUTOMATED_FIELDS_HIGHLIGHTED: 'Automated fields are highlighted.',
  MULTI_TIN_IMPACT_UPLOAD_SUPPRESS_MSG:
    'Documents with Tax IDs that are linked to multiple affiliations must be uploaded to IMPACT manually.',
  EXISTING_DOCUMENTS_DESC:
    'Documents saved in this system are only visible to the individual who created them.  Please note that the ability to retrieve and display data using a Parent Entity name or Genesis ID depends on how each healthcare organization is configured within the Genesis system.',
  ERROR_FORMATTING_CURRENT_STATE_DATA: 'Error formatting current state data:',
  CHARACTER_RESTRICTION_TITLE: 'Only standard keyboard characters and bullet points are allowed',
};
